import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  OnDestroy,
  Renderer2,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import {
  EmailValidator,
  ValidationService,
} from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { RestService } from '../../shared/providers/rest.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { v4 as uuidv4 } from 'uuid';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { IUserInput } from '../../shared/models/UserInputModel';
import { IUserCreationResponseModel } from '../../shared/models/UserCreationResponseModel';
import { IUserDetails } from '../../shared/models/UserDetailsOutputModel';
import { IResponseModel } from '../../shared/models/ResponseModel';
import { IFileUpload } from '../../shared/models/fileupload';
import { IAddStandardUserModel } from '../../shared/models/AddStandardUserModel';
import { IStandardUserProperties } from '../../shared/models/StandardUserProperties';
import { UserRole, UserStatus } from '../../shared/enum/enum';
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { IAddStandardUserPropertiesModel } from '../../shared/models/AddStandardUserPropertiesModel';
import { MatSelect } from '@angular/material/select';

enum Tabs {
  StandardUsers = 1,
}

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.css'],
})
export class PreferenceComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  userId: number = 0;
  DataEntryPropertyId: number = 0;
  propertyGuid: string = '';
  dealContacts = [];
  searchText = '';
  table: DataTableDirective;
  modalRefDelete: BsModalRef;
  modalRefEdit: BsModalRef;
  modalRefRemoveAccess: BsModalRef;
  modalRefGrantAccess: BsModalRef;
  deleteId = 0;
  tabs = Tabs;
  currentTab = Tabs.StandardUsers;
  showCreate = false;
  filterData: any;
  editStandardUserId = 0;
  user: any;
  editUser: any;
  isSubmitted = false;
  propertyId: any = uuidv4();
  @Input() UserGuid: string = '0000';
  dtOptions = {};
  dtTrigger = new Subject();
  header = 'Add';
  principalName = '';
  IsEditMode: boolean = false;
  @ContentChild('profilePic') private profilePic: any;
  @ViewChild('addstandarduser') accept: TemplateRef<null>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  userInputModel = {} as IUserInput;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  userGuid: string = '';
  userDetailsOutput = {} as IUserDetails;
  PrincipalUserGuid: string = '0000';
  IsAdd: boolean = false;
  DefaultIndexCount: number = 0;
  userRole = UserRole;
  imageIdToDelete: number;
  deleteTask: string;
  deleteTaskId: number;
  standardUserProperties = {} as IAddStandardUserPropertiesModel;
  addUserForm: FormGroup;
  userEmailID: string;
  responseModel = {} as IResponseModel;
  fileUploadType: string = 'single';
  inputFileUpload = {} as IFileUpload;
  DDColumns = [];
  selectedpropertyIds = [];
  properties = [];
  IsUserValid: boolean = false;
  grantAccessStandardUserEmail: string = '';
  @ViewChild('GrantAccess') grantAccess: TemplateRef<any>;
  propertyList = [];
  propertyIds = [];
  IsLoading = false;
  //defaultContactText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Property',
  //  checkAll: 'Select all',
  //  uncheckAll: 'Unselect all',
  //  searchEmptyResult: 'No Data Available'

  //};
  addStandardUserModel = {} as IAddStandardUserModel;
  addedProperties: Array<IStandardUserProperties> = [];
  protected readonly BASE_URL: string = environment.base_url;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;

  defaultTypeSettings = {
    singleSelection: false,
    text: 'Select Property',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };

  constructor(
    private modalService: BsModalService,
    private _toastService: ToastService,
    private loader: LoaderService,
    private http: HttpClient,
    private rest: RestService,
    private _propertyManagementService: PropertyManagementService,
    private _ValidationService: ValidationService,
    public authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _userManagerService: UserManagerService,
    private _fileUploadService: FileUploadService,
    public validationService: ValidationService,
   private renderer: Renderer2,

  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (
        params['user'] != '' &&
        params['user'] != null &&
        params['user'] != undefined
      ) {
        this.userGuid = params['user'];
      }
      if (
        params['PrincipalUserGuid'] != '' &&
        params['PrincipalUserGuid'] != null &&
        params['PrincipalUserGuid'] != undefined
      ) {
        this.PrincipalUserGuid = params['PrincipalUserGuid'];
      }
      if (
        params['UserGuid'] != '' &&
        params['UserGuid'] != null &&
        params['UserGuid'] != undefined
      ) {
        this.PrincipalUserGuid = params['UserGuid'];
      }
    });
  }

  result = [];

  selectedFiles: string[] = [];
  clearFiles: number = 0;

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;
  }

  selectedFilePathEmitter(selectedFilePathEmitter: any) {
    this.userInputModel.ProfilePicPath = selectedFilePathEmitter;
    /* this.profilePic.nativeElement.src = selectedFilePathEmitter;*/
  }

  setUploadDefaultValues() {
    this.inputFileUpload.fileCategoryId = 251;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 301;
    this.inputFileUpload.documentName = 'User Profile Pictuer';
    this.inputFileUpload.type = 'Images';
  }

  ngOnInit() {
    this.user = this.authService.user;
    this.userId = this.user.Id;
    this.loadStandardUsers();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe());
  }
  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }
  initalAddPageLoading() {
    this.addUserForm = new FormGroup({
      txtFirstName: new FormControl(this.userInputModel.FirstName, [
        Validators.required,
      ]),
      txtLastName: new FormControl(this.userInputModel.LastName, [
        Validators.required,
      ]),
      txtEmail: new FormControl(this.userInputModel.EmailAddress, [
        Validators.required,
        EmailValidator,
      ]),
      txtPhone: new FormControl(this.userInputModel.PhoneNumber, [
        Validators.required,
        Validators.minLength(10),
      ]),
      lstRole: new FormControl(this.propertyIds, [Validators.required]),
    });
    this.userInputModel.CreatedById = this.user.Id;
    this.setUploadDefaultValues();
    this.userInputModel.StateId = 0;
    this.userInputModel.CityId = 0;
    this.userInputModel.UserRoleId = 0;
    this.userInputModel.UserStatus = 0;
    this.userInputModel.PrincipalUserGuid = this.PrincipalUserGuid;
    if (
      this.userInputModel.ProfilePicPath === undefined ||
      this.userInputModel.ProfilePicPath === null ||
      this.userInputModel.ProfilePicPath.trim().length <= 0
    ) {
      this.userInputModel.ProfilePicPath =
        '/../../../assets/img/default-profile-img.png';
    }
    this.getProperties();
  }

  get txtFirstName() {
    return this.addUserForm.get('txtFirstName');
  }
  get txtLastName() {
    return this.addUserForm.get('txtLastName');
  }
  get txtEmail() {
    return this.addUserForm.get('txtEmail');
  }
  get txtPhone() {
    return this.addUserForm.get('txtPhone');
  }
  get lstRole() {
    return this.addUserForm.get('lstRole');
  }

  onTabClick(tab) {
    this.currentTab = tab;
  }

  async getProperties() {
    let principalId =
      this.userGuid != null && this.userGuid != '' ? this.userGuid : '0000';
    await this._propertyManagementService
      .getPrincipalPortfolioProperties(
        this.user.Id,
        this.PrincipalUserGuid,
        principalId
      )
      .subscribe((response) => {
        if (response != null && response.length > 0) {
          this.properties = response;
          this.propertyList = response.map((o) => {
            return { id: o.Id, name: o.DisplayName + o.Address };
          });
        }
        if (
          this.userGuid != undefined &&
          this.userGuid != '' &&
          this.userGuid != null
        ) {
          this.loader.display(true);
          this._userManagerService
            .getUserDetails(this.userGuid)
            .subscribe((response) => {
              this.userEmailID = response.Email;
              this.userInputModel.UserGuid = this.userGuid;
              this.userInputModel.FirstName = response.FirstName;
              this.userInputModel.LastName = response.LastName;
              this.userInputModel.EmailAddress = response.Email;
              this.userInputModel.PhoneNumber = response.Phoneno;
              this.userInputModel.Address1 = response.Address1;
              this.userInputModel.Address2 = response.Address2;
              this.userInputModel.StateId = response.StateId;
              this.userInputModel.CityId =
                response.CityId == null ? 0 : response.CityId;
              this.userInputModel.Zip = response.Zip;
              this.userInputModel.UserRoleId = response.UserRoleId;
              this.userInputModel.UserStatus = response.UserStatusId;
              this.userInputModel.ProfilePicPath = response.ProfilePicPath;

              this.userInputModel.Password =
                '***********************************************************************';

              this.userInputModel.CompanyName = response.CompanyName;
              this.imageIdToDelete = response.ImageId;
              this.userId = response.Id;
              this._userManagerService
                .GetStandardUserProperties(this.userId, this.PrincipalUserGuid)
                .subscribe((res) => {
                  this.loader.display(false);
                  this.addedProperties = res.data ? res.data : [];
                  if (this.addedProperties.length > 0) {
                    this.addedProperties.forEach((s) => {
                      let property = this.properties.find(
                        (p) => p.Id == s.PropertyId
                      );
                      if (property != undefined) {
                        this.propertyIds.push(property.Id);
                        property.IsChecked = true;
                      }
                    });
                  }
                });

              this.IsEditMode = true;
              this.header = 'Edit User Details';

              if (
                this.userInputModel.ProfilePicPath === undefined ||
                this.userInputModel.ProfilePicPath === null ||
                this.userInputModel.ProfilePicPath.trim().length <= 0
              ) {
                this.userInputModel.ProfilePicPath =
                  '/../../../assets/img/default-profile-img.png';
              }
            });
        } else {
          this.IsAdd = true;
          this.userInputModel.UserStatus = UserStatus.Active;
          this.userInputModel.BrokerageId = null;
        }

        if (
          this.userInputModel.ProfilePicPath === undefined ||
          this.userInputModel.ProfilePicPath === null ||
          this.userInputModel.ProfilePicPath.trim().length <= 0
        ) {
          this.userInputModel.ProfilePicPath =
            '/../../../assets/img/default-profile-img.png';
        }
      });
  }

  uploadFiles() {
    this._fileUploadService
      .uploadFiles(this.inputFileUpload, this.selectedFiles)
      .subscribe((response) => {
        this.clearFiles++;
        this.redirectToListingPage();
      });
  }

  loadStandardUsers() {
    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      search: true,
      ordering: true,
      seaching: true,
      paging: true,
      pageLength: 20,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      order: [[2, 'desc']],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          UserId: this.userId,
          UserGuid: this.UserGuid,
        };
        const httpHeader = this._ValidationService.GetAuthHeader();
        this._subscriptions.push(
          that.http
            .post<DataTablesResponse>(
              this.BASE_URL + '/dataentryproperty/getallstandardusers',
              dataTablesParameters,
              httpHeader
            )
            .subscribe((resp) => {
              that.dealContacts = resp.data ? resp.data : [];
              that.filterData = resp.data ? resp.data : [];
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: [],
                });
                if (resp.data.length === 0) {
                  $('.dataTables_paginate.paging_full_numbers').hide();
                } else {
                  $('.dataTables_paginate.paging_full_numbers').show();
                }
                $('.paginate_button.first,.paginate_button.last').hide();
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
                $('.dataTables_paginate.paging_full_numbers').hide();
              }
              this.IsLoading = false;
            })
        );
      },
      columns: [
        { data: 'Actions' },
        { data: 'FirstName' },
        { data: 'AssociatedPropertyCount' },
        { data: 'RecentActivity' },
      ],
    };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
    this.initalAddPageLoading();
  }

  delete() {
    this._userManagerService
      .DeleteStandardUser(this.deleteId)
      .subscribe((res) => {
        this._toastService.addToast({
          title: 'Delete',
          msg: `Deleted Successfully`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success',
        });
        this.modalRefDelete.hide();
        this.redrawTable();
      });
  }

  search(text: string) {
    this.dtElement.dtInstance.then((x) => x.search(text).draw());
  }

  deleteUser: any;
  openDeleteModal(template: TemplateRef<any>, classes: any, id: number) {
    this.deleteId = id;
    this.deleteUser = this.dealContacts.find((u) => u.Id == this.deleteId);
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }

  openEditModal(template: TemplateRef<any>, classes: any, id: number) {
    this.loader.display(true);
    this.editStandardUserId = id;
    this.selectedRows = [];
    this.editUser = this.dealContacts.find(
      (u) => u.Id == this.editStandardUserId
    );
    this._subscriptions.push(
      this._userManagerService
        .GetStandardUserProperties(this.editUser.UserId, this.PrincipalUserGuid)
        .subscribe((res) => {
          this.loader.display(false);
          this.addedProperties = res.data ? res.data : [];
          if (this.addedProperties.length > 0) {
            if (this.addedProperties.length == this.properties.length) {
              this.selectAll = true;
            } else {
              this.selectAll = false;
            }
            this.properties.forEach((s) => {
              let property = this.addedProperties.find(
                (p) => p.PropertyId == s.Id
              );
              if (property != undefined) {
                this.selectedRows.push(s);
                s.IsChecked = true;
              } else {
                s.IsChecked = false;
              }
            });
          }
        })
    );
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  propertiesToRemove = [];
  EditAccess(template: TemplateRef<any>, classes: any) {
    this.propertiesToRemove = [];
    this.addedProperties.forEach((s) => {
      let removeProperty = this.selectedRows.find((u) => u.Id == s.PropertyId);
      if (removeProperty == null || removeProperty == undefined) {
        this.propertiesToRemove.push(s);
      }
    });
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      if (this.propertiesToRemove.length > 0) {
        this.modalRefEdit.hide();
        this.modalRefRemoveAccess = this.modalService.show(template, {
          class: classes,
        });
      } else {
        this.RemoveProperty();
      }
    } else {
      this._toastService.addToast({
        title: 'Error',
        msg: 'Please select at least one property',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  RemoveProperty() {
    this.standardUserProperties.DataEntryPropertyIds = [];
    this.standardUserProperties.StandardUserId = this.editStandardUserId;
    this.selectedRows.forEach((s) => {
      this.standardUserProperties.DataEntryPropertyIds.push(s.Id);
    });
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      this.loader.display(true);
      this._propertyManagementService
        .updateStandarduserProperties(this.standardUserProperties)
        .subscribe((response) => {
          let value = response;
          this.loader.display(false);
          if (
            this.modalRefRemoveAccess != undefined &&
            this.modalRefRemoveAccess != null
          ) {
            this.modalRefRemoveAccess.hide();
          }
          if (this.modalRefEdit != undefined && this.modalRefEdit != null) {
            this.modalRefEdit.hide();
          }
          if (value == true) {
            this._toastService.addToast({
              title: 'Success',
              msg: 'Access edited successfully',
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'success',
            });
            this.redrawTable();
          } else {
            this._toastService.addToast({
              title: 'Error Occurred',
              msg: this.userCreationResponseModel.FailureMessage,
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'error',
            });
          }
        });
    } else {
      this._toastService.addToast({
        title: 'Error',
        msg: 'Please select at least one property',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  modalRef: BsModalRef;
  create(template: TemplateRef<any>, classes: any) {
    this.propertyIds = [];
    this.userInputModel.FirstName = '';
    this.userInputModel.LastName = '';
    this.userInputModel.EmailAddress = '';
    this.userInputModel.PhoneNumber = '';
    this.userInputModel.ProfilePicPath =
      '/../../../assets/img/default-profile-img.png';
    this.openModal(this.accept, 'portfolio-bov-modal');

    //this.modalRef = this.modalService.show(template, { class: classes });

    /* this.router.navigate(['/standarduser-add'], { queryParams: { PrincipalUserGuid: this.UserGuid } });*/
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
    this.isSubmitted = false;
    this.addPropertyValidation = '';
    this.showCreate = true;
  }

  onClose() {
    this.modalRef.hide();
    this.showCreate = false;
  }

  selectedRows = [];
  onCheckboxChange(event, Id) {
    if (event) {
      let prop = this.properties.find((x) => x.Guid == Id);
      this.selectedRows.push(prop);
      if (this.properties.length == this.selectedRows.length) {
        this.selectAll = true;
      }
    } else {
      if (this.selectedRows.findIndex((x) => x.Guid == Id) > -1) {
        let index = this.selectedRows.findIndex((x) => x.Guid == Id);
        this.selectedRows.splice(index, 1);
        if (this.properties.length != this.selectedRows.length) {
          this.selectAll = false;
        }
      }
    }
  }

  selectAll = false;

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    } else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.properties.forEach((item) => {
      item.IsChecked = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        let selectedRow = this.selectedRows.find((x) => x.Guid == item.Guid);
        if (selectedRow == undefined || selectedRow == null) {
          this.selectedRows.push(item);
        }
      } else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(
          this.selectedRows.findIndex((x) => x.Guid == item.Guid),
          1
        );
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  AddPropertyToStandardUser() {
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Successfully added properties',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success',
      });
    } else {
      this._toastService.addToast({
        title: 'Error',
        msg: 'Please select at least one property',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  emailvalidation: string = '';
  addPropertyValidation: string = '';
  phoneValid: boolean = true;

  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  specCharValMsg = '!@#$%^&*()_+-=[]{};"\\|<>/? not allowed';
  saveUser() {
    this.isSubmitted = true;
    this.userInputModel.UserRoleId = this.userRole.Principal;
    this.userInputModel.IsStandardUser = true;
    let IsValid: boolean = true;

    if (this.validationService.IsinValid(this.userInputModel.FirstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      IsValid = false;
    } else {
      if (
        this.validationService.isSpecialCharacterExist(
          this.userInputModel.FirstName
        )
      ) {
        this.firstNameValid = false;
        IsValid = false;
        this.showFNSpecCharVal = true;
      } else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }
    }

    if (this.validationService.IsinValid(this.userInputModel.LastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      IsValid = false;
    } else {
      if (
        this.validationService.isSpecialCharacterExist(
          this.userInputModel.LastName
        )
      ) {
        this.lastNameValid = false;
        IsValid = false;
        this.showLNSpecCharVal = true;
      } else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }

    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      IsValid = false;
    } else if (
      this.validationService.isEmail(this.userInputModel.EmailAddress) ==
        false &&
      !this.validationService.IsinValid(this.userInputModel.EmailAddress)
    ) {
      this.emailValid = false;
      IsValid = false;
      this.emailvalidation = 'invalid Email address';
    } else {
      this.emailValid = true;
      this.emailvalidation = '';
    }

    if (this.validationService.IsinValid(this.userInputModel.PhoneNumber)) {
      this.phoneValid = false;
      IsValid = false;
    } else {
      this.phoneValid = true;
    }

    if (this.propertyIds.length <= 0) {
      IsValid = false;
      this.addPropertyValidation = 'Select at least one property.';
    } else {
      this.addPropertyValidation = '';
    }

    if (IsValid) {
      if (this.selectedFiles.length > 0) {
        this.loader.display(true);
      }

      if (this.userInputModel.EmailAddress) {
        this.userInputModel.DataEntryPropertyIds = [];
        this.propertyIds.forEach((s) => {
          this.userInputModel.DataEntryPropertyIds.push(s);
        });
        if (!this.IsEditMode) {
          this.loader.display(true);
          this.addStandardUserModel.Email = this.userInputModel.EmailAddress;
          this.addStandardUserModel.AssociatedPrincipalId =
            this.userInputModel.CreatedById;
          let CreatedUserGuid =
            this.PrincipalUserGuid != null &&
            this.PrincipalUserGuid != undefined
              ? this.PrincipalUserGuid
              : '0000';
          this.addStandardUserModel.AssociatedUserGuid = CreatedUserGuid;
          this._userManagerService
            .CheckIfUserExists(this.addStandardUserModel)
            .subscribe((response) => {
              this.responseModel = response;
              if (!this.responseModel.IsSuccess) {
                this._userManagerService
                  .createUser(this.userInputModel)
                  .subscribe((response) => {
                    this.isSubmitted = false;
                    this.userCreationResponseModel = response;
                    this.loader.display(false);
                    if (this.userCreationResponseModel.Success == true) {
                      if (this.selectedFiles.length > 0) {
                        this.inputFileUpload.objectId =
                          this.userCreationResponseModel.Id;
                        this.inputFileUpload.id =
                          this.userCreationResponseModel.Id;
                        this.uploadFiles();
                      } else {
                        this.redirectToListingPage();
                      }
                    } else {
                      this._toastService.addToast({
                        title: 'Error Occurred',
                        msg: this.userCreationResponseModel.FailureMessage,
                        timeout: 5000,
                        theme: 'bootstrap',
                        position: 'bottom-right',
                        type: 'error',
                      });
                    }
                  });
              } else if (
                this.responseModel.IsSuccess &&
                this.responseModel.ErrorMessage != ''
              ) {
                this.properties.forEach((p) => {
                  p.IsChecked = false;
                });

                this.propertyIds = [];

                this.loader.display(false);
                this._toastService.addToast({
                  title: 'Error Occurred',
                  msg: this.responseModel.ErrorMessage,
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'error',
                });
              } else {
                if (this.IsUserValid) {
                  this.addStandardUserModel.Email =
                    this.userInputModel.EmailAddress;
                  this.addStandardUserModel.AssociatedPrincipalId =
                    this.userInputModel.CreatedById;
                  this.addStandardUserModel.DataEntryPropertyIds =
                    this.userInputModel.DataEntryPropertyIds;
                  this._userManagerService
                    .AddExistingUserAsStandardUser(this.addStandardUserModel)
                    .subscribe((response) => {
                      this.loader.display(false);
                      this._toastService.addToast({
                        title: 'Success',
                        msg: 'User added successfully',
                        timeout: 5000,
                        theme: 'bootstrap',
                        position: 'bottom-right',
                        type: 'success',
                      });
                      this.modalRef.hide();
                      this.redrawTable();
                    });
                } else {
                  this.loader.display(false);
                  if (
                    this.responseModel.UserName != null &&
                    this.responseModel.UserName != '' &&
                    this.responseModel.UserName != undefined
                  ) {
                    this.principalName = this.responseModel.UserName;
                  }
                  this.checkDuplicateUser();
                }
              }
            });
        } else {
          this.loader.display(true);
          this._userManagerService
            .updateUser(this.userInputModel)
            .subscribe((response) => {
              this.userCreationResponseModel = response;
              this.loader.display(false);
              if (this.userCreationResponseModel.Success == true) {
                if (this.selectedFiles.length > 0) {
                  this.inputFileUpload.objectId =
                    this.userCreationResponseModel.Id;
                  this.inputFileUpload.id = this.userCreationResponseModel.Id;
                  this.uploadFiles();
                } else {
                  this.redirectToListingPage();
                }
              } else {
                this._toastService.addToast({
                  title: 'Error Occurred',
                  msg: this.userCreationResponseModel.FailureMessage,
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'error',
                });
              }
            });
        }
      }
    }
  }

  cancel() {
    this.modalRef.hide();
  }

  deleteroute() {
    this.modalRefDelete.hide();
    this.router.navigateByUrl(
      '/standarduser-detail?PrincipalUserGuid=' +
        this.userGuid +
        '&user=' +
        this.deleteUser.UserGuid
    );
  }

  editroute() {
    this.modalRefEdit.hide();
    this.router.navigateByUrl(
      '/standarduser-detail?PrincipalUserGuid=' +
        this.userGuid +
        '&user=' +
        this.deleteUser.UserGuid
    );
  }

  removeAccessroute() {
    this.modalRefRemoveAccess.hide();
    this.router.navigateByUrl(
      '/standarduser-detail?PrincipalUserGuid=' +
        this.userGuid +
        '&user=' +
        this.deleteUser.UserGuid
    );
  }

  checkDuplicateUser() {
    this.modalRefGrantAccess = this.modalService.show(this.grantAccess);
  }
  changeStatus(type: number) {
    if (type == 1) {
      this.IsUserValid = false;
    } else {
      this.IsUserValid = true;
    }

    this.modalRefGrantAccess.hide();
  }

  validateemail() {
    if (
      this.validationService.isEmail(this.userInputModel.EmailAddress) ==
        false &&
      !this.validationService.IsinValid(this.userInputModel.EmailAddress)
    ) {
      this.emailValid = false;
      this.emailvalidation = 'invalid Email address';
    } else {
      this.emailValid = true;
      this.emailvalidation = '';
    }
    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
    }
  }

  IsinValid(value: any) {
    if (value == undefined || value == '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }

  setDefault(event: any, index: number) {
    if (event.target.checked) {
      this.DefaultIndexCount++;
    } else {
      this.DefaultIndexCount--;
    }
  }
  redirectToListingPage() {
    if (!this.IsEditMode) {
      this._toastService.addToast({
        title: 'Success',
        msg: 'User Added Successfully',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success',
      });
    } else {
      this.authService.reloadUserDetails(true);
      this._toastService.addToast({
        title: 'Success',
        msg: 'User Details Updated Successfully',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success',
      });
    }
    /*this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.PrincipalUserGuid, opentab: 6 } });*/

    this.modalRef.hide();
    this.redrawTable();
  }

  onRemoveImage(id: number) {
    if (id > 0) {
      //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 2000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      this.loader.display(true);
      this._userManagerService.deleteImage(id).subscribe((response) => {
        if (response.toString() === 'true') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Image deleted successfully!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          this.loader.display(false);
          this.userInputModel.ProfilePicPath =
            '/../../../assets/img/default-profile-img.png';
          this.imageIdToDelete = null;
          $('.profileupload')[0].hidden = false;
          this.authService.reloadUserDetails(true);
        } else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Image could not be deleted',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
        }
      });
    } else {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Image deleted successfully!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success',
      });
    }
  }

  openModalForDelete(
    template: TemplateRef<any>,
    classes,
    taskId: number,
    task: string
  ) {
    this.deleteTask = task;
    this.deleteTaskId = taskId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  redrawTable() {
    this.dtElement.dtInstance.then((x) => x.draw(false));
  }

  selectAllProperty() {
    this.propertyIds = this.propertyList.map((property) => property.id);
  }

  unselectAllProperty() {
    this.propertyIds = [];
  }
}
